<template>
  <div>
    <!-- 创意天地 -->
    <section class="creative-section">
      <div class="container">
        <div class="section-head">
          <h2 class="section-title">{{ $t('overview.creativeHub.title') }}</h2>
          <p class="section-sub">{{ $t('overview.creativeHub.subtitle') }}</p>
        </div>
      </div>
    </section>

    <!-- 案例展示部分 -->
    <section class="showcase-section">
      <div class="container">
        <div class="section-head" style="padding-top: 3rem;">
          <h2 class="section-title">{{ $t('overview.showcase.title') }}</h2>
          <p class="section-sub">{{ $t('overview.showcase.subtitle') }}</p>
        </div>

        <!-- 第一个 案例头部 -->
        <div class="showcase-row">
          <div v-for="(item, idx) in cShowcaseItems" :key="`wrap-${idx}`" style="display: contents">
            <div class="showcase-card" :key="`card-${idx}`">
              <div class="showcase-image" :style="{ backgroundImage: 'url(' + item.image + ')' }"></div>
              <div class="showcase-content">
                <h3 class="showcase-title">{{ $t(item.title) }}</h3>
                <p class="showcase-desc">{{ $t(item.desc) }}</p>
              </div>
            </div>
            <div v-if="idx < showcaseItems.length - 1" class="showcase-arrow" :key="`arrow-${idx}`">
              <i class="arrow-icon">→</i>
            </div>
          </div>
        </div>
        <!-- 第一个 案例底部 -->
        <div class="showcase-cta">
          <el-button
            type="primary"
            size="large"
            class="cta-button"
            @click="onContact(1)"
            style="margin-bottom: 30px;"
          >
            <i class="el-icon-s-promotion"></i>
            {{ $t('overview.learnMore') }}
          </el-button>
        </div>

        <!-- 第二个 案例头部 -->
        <div class="showcase-row">
          <div v-for="(item, idx) in cShowcase22Items" :key="`wrap2-${idx}`" style="display: contents">
            <div class="showcase-card" :key="`card2-${idx}`">
              <div class="showcase-image" :style="{ backgroundImage: 'url(' + item.image + ')' }"></div>
              <div class="showcase-content">
                <h3 class="showcase-title">{{ $t(item.title) }}</h3>
                <p class="showcase-desc">{{ $t(item.desc) }}</p>
              </div>
            </div>
            <div v-if="idx < showcase22Items.length - 1" class="showcase-arrow" :key="`arrow2-${idx}`">
              <i class="arrow-icon">→</i>
            </div>
          </div>
        </div>
        <!-- 第二个：案例底部 -->
        <div class="showcase-cta" style="padding-bottom: 4rem;">
          <el-button type="primary" size="large" class="cta-button" @click="onContact(22)">
            <i class="el-icon-s-promotion"></i>
            {{ $t('overview.learnMore') }}
          </el-button>
        </div>

        <!-- 第三个 案例头部 -->
        <div class="showcase-row">
          <div v-for="(item, idx) in cShowcase2Items" :key="`wrap3-${idx}`" style="display: contents">
            <div class="showcase-card" :key="`card3-${idx}`">
              <div class="showcase-image" :style="{ backgroundImage: 'url(' + item.image + ')' }"></div>
              <div class="showcase-content">
                <h3 class="showcase-title">{{ $t(item.title) }}</h3>
                <p class="showcase-desc">{{ $t(item.desc) }}</p>
              </div>
            </div>
            <div v-if="idx < showcase2Items.length - 1" class="showcase-arrow" :key="`arrow3-${idx}`">
              <i class="arrow-icon">→</i>
            </div>
          </div>
        </div>
        <!-- 第三个：案例底部 -->
        <div class="showcase-cta" style="padding-bottom: 4rem;">
          <el-button type="primary" size="large" class="cta-button" @click="onContact(2)">
            <i class="el-icon-s-promotion"></i>
            {{ $t('overview.learnMore') }}
          </el-button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ShowcaseSection',
  props: {
    showcaseItems: {
      type: Array,
      required: false,
      default: () => []
    },
    showcase22Items: {
      type: Array,
      required: false,
      default: () => []
    },
    showcase2Items: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  emits: ['contact'],
  computed: {
    cShowcaseItems() {
      return (this.showcaseItems && this.showcaseItems.length)
        ? this.showcaseItems
        : [
            { title: 'overview.anli101', desc: 'overview.anli102', image: require('@/assets/images/homepageimg/创意1.1.png') },
            { title: 'overview.anli201', desc: 'overview.anli202', image: require('@/assets/images/homepageimg/创意1.2.png') },
            { title: 'overview.anli301', desc: 'overview.anli302', image: require('@/assets/images/homepageimg/创意1.3.png') }
          ]
    },
    cShowcase22Items() {
      return (this.showcase22Items && this.showcase22Items.length)
        ? this.showcase22Items
        : [
            { title: 'overview.anli101', desc: 'overview.anli102', image: require('@/assets/images/homepageimg/创意3.1.png') },
            { title: 'overview.anli201', desc: 'overview.anli202', image: require('@/assets/images/homepageimg/创意3.2.png') },
            { title: 'overview.anli301', desc: 'overview.anli302', image: require('@/assets/images/homepageimg/创意3.3.png') }
          ]
    },
    cShowcase2Items() {
      return (this.showcase2Items && this.showcase2Items.length)
        ? this.showcase2Items
        : [
            { title: 'overview.anli101', desc: 'overview.anli102', image: require('@/assets/images/homepageimg/创意2.1.png') },
            { title: 'overview.anli201', desc: 'overview.anli202', image: require('@/assets/images/homepageimg/创意2.2.png') },
            { title: 'overview.anli301', desc: 'overview.anli302', image: require('@/assets/images/homepageimg/创意2.3.png') }
          ]
    }
  },
  methods: {
    onContact(num) {
      this.$emit('contact', num)
    }
  }
}
</script>

<style scoped>
/* 创意天地 */
.creative-section {
  padding: 2rem 0;
  background-image: url('~@/assets/images/homepageimg/创意天地.jpg');
  background-size: cover;
  background-position: center;
  position: relative;
}

.creative-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
}

.creative-section .container {
  position: relative;
}

.section-head {
  text-align: center;
  margin-bottom: 1.5rem;
}

.section-title {
  font-size: 2rem;
  color: #333;
  margin-bottom: 1rem;
  font-weight: 600;
}

.creative-section .section-title,
.creative-section .section-sub {
  color: #fff;
}

.section-sub {
  color: #666;
  font-size: 0.95rem;
}

/* 案例展示部分 */
.showcase-section {
  padding: 0rem 0;
  background: linear-gradient(135deg, #fff5f0 0%, #ffffff 100%);
}

.showcase-section .section-title {
  font-size: 2rem;
  color: #333;
  margin-bottom: 1rem;
  font-weight: 600;
}

.showcase-section .section-sub {
  color: #666;
  font-size: 1rem;
  line-height: 1.8;
  max-width: 900px;
  margin: 0 auto;
}

.showcase-row {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  margin-bottom: 3rem;
}

.showcase-card {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  flex: 0 0 280px;
}

.showcase-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.12);
}

.showcase-image {
  height: 200px;
  background-size: cover;
  background-position: center;
  position: relative;
  overflow: hidden;
}

.showcase-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.showcase-content {
  padding: 1.5rem;
}

.showcase-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.8rem;
}

.showcase-desc {
  font-size: 0.9rem;
  color: #666;
  line-height: 1.6;
  margin: 0;
}

.showcase-arrow {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
}

.arrow-icon {
  font-size: 2.4rem;
  color: #FF631E;
  font-weight: bold;
  font-style: normal;
}

.showcase-cta {
  text-align: center;
}

.cta-button {
  background: linear-gradient(135deg, #FF631E, #ff7a3d);
  border: none;
  padding: 1rem 2.5rem;
  font-size: 1.1rem;
  font-weight: 600;
  border-radius: 50px;
  box-shadow: 0 6px 20px rgba(255, 99, 30, 0.3);
  transition: all 0.3s ease;
}

.cta-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(255, 99, 30, 0.4);
}

@media (max-width: 992px) {
  .showcase-row {
    flex-direction: column;
    gap: 1.5rem;
    align-items: center;
  }

  .showcase-card {
    flex: 0 0 auto;
    width: 100%;
    max-width: 400px;
  }

  .showcase-arrow {
    transform: rotate(90deg);
    height: 40px;
  }

  .arrow-icon {
    font-size: 1.5rem;
  }

  .showcase-section .section-title {
    font-size: 1.75rem;
  }
}

@media (max-width: 768px) {
  .showcase-section {
    padding: 3rem 0;
  }

  .showcase-image {
    height: 160px;
  }

  .showcase-card {
    flex: 0 0 auto;
    width: 100%;
    max-width: 320px;
  }

  .cta-button {
    padding: 0.875rem 2rem;
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .showcase-card {
    max-width: 280px;
  }

  .showcase-image {
    height: 140px;
  }

  .showcase-content {
    padding: 1rem;
  }

  .showcase-title {
    font-size: 1rem;
  }

  .showcase-desc {
    font-size: 0.85rem;
  }
}
</style>